<template>
  <div class="space-y-7 mt-7">
    <div class="flex flex-row items-center justify-center space-x-3">
      <h1 class="text-blue-800 text-4xl font-extrabold">NPS =</h1>
      <CircleNumber :number="'%'" :color="'green'" :size="33" />
      <h1 class="text-black text-4xl font-extrabold">-</h1>
      <CircleNumber :number="'%'" :color="'red'" :size="33" />
    </div>
  </div>
</template>

<script>
import CircleNumber from './CircleNumber.vue'

export default {
  components: {
    CircleNumber
  }
}
</script>


// WEBPACK FOOTER //
// src/components/schema/NpsSchema.vue